import { Chip } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';

export const NewLabelStyled = styled(({ text, ...rest }: { text: string }) => (
  <Chip size="s" text={text} variant="blue" {...rest} />
))(({ theme }) => ({
  height: 20,
  padding: '3px 8px',
  alignItems: 'center',
  display: 'flex',
  marginLeft: 8,
  '& .chip-text': {
    ...theme.typography.caption,
    fontSize: 12,
    lineHeight: '100%',
  } as CSSObject,
}));
